<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive :include="keepAliveNames">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
// 需要缓存的组件名列表（组件 name 与路由 name 保持一致）
const keepAliveNames = ref([])

watch(
  () => route.name,
  () => {
    if (route.meta?.keepAlive) {
      const name = route.name
      if (name && !keepAliveNames.value.includes(name)) {
        keepAliveNames.value.push(name)
      }
    }
  },
  { immediate: true }
)
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  overscroll-behavior-y: none;
}
</style>
